document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      const button = form.querySelector('button[type="submit"]');
      if (!button) return;
      button.disabled = true;
      const original = button.textContent;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({id: form.querySelector('[name="id"]').value, quantity: Number(form.querySelector('[name="quantity"]')?.value || 1)})
        });
        if (!response.ok) throw new Error('Cart error');
        button.textContent = 'ADDED TO CART';
        setTimeout(() => button.textContent = original, 1400);
      } catch(err) {
        form.submit();
      } finally {
        setTimeout(() => button.disabled = false, 1400);
      }
    });
  });
});
